// Block duplizieren (TTSView "Duplicate"): Text, Parameter und alle Takes
// werden übernommen, der Favorit NICHT — der Klon startet ohne Stern und
// ohne Timeline-Position. Vorher wurden favIdx und offset mitkopiert: der
// Klon-Chip lag exakt unter dem Original, unsichtbar, aber der Stern war
// gesetzt (Philip, 2026-09-14). Der Sprecher wählt im Klon explizit einen
// Take, der dann wie gewohnt auto-positioniert wird.
//
// Jeder Take bekommt eine frische id: Take-IDs sind projektweit eindeutig
// (Decode-Cache, Stern-Hinweis, IDB-Audio-Schlüssel). Die Take-Nummer im
// Präfix `take-{n}-…` bleibt erhalten, damit das Chip-Label "Take n" wie im
// Original heißt. Der ArrayBuffer wird geteilt (immutable).

import type { Block, Take } from '@shared/types';
import { newBlockId } from './blockId';

export function cloneBlockForDuplicate(
  src: Block,
  now: () => number = Date.now,
): Block {
  const stamp = now();
  const takes: Take[] = src.takes.map((t, i) => ({
    id: `${t.id.replace(/^(take-\d+)-.*$/, '$1')}-${stamp}-${i}`,
    buffer: t.buffer,
    duration: t.duration,
    model: t.model,
    paramsSnapshot: t.paramsSnapshot,
    voiceId: t.voiceId,
  }));
  return {
    ...src,
    // Eigene Block-ID — der Klon ist ein neuer Block (Audit M7).
    id: newBlockId(),
    takes,
    favIdx: -1,
    offset: 0,
    pinned: false,
    takeCounter: src.takeCounter,
    // Frisches Edit-Ziel — Lock fällt, auch wenn das Original gesperrt war.
    locked: false,
  };
}
